
import { Deserializer } from 'jsonapi-serializer';

import createDebug from 'debug';
import { genericError } from '../models/GenericError';
import { ListQuery } from '../models/ListQuery';
import { Name } from '../models/Name';
import { PaginationModel } from '../models/Pagination';
import { PrintTemplate } from '../models/PrintTemplate';
import { APIConnector } from './api/APIConnector';
import { createPagination } from './utilities/paginationBuilder';
import { processServerError, getConstraintViolation } from './utilities/ServiceError';
import { createPartialURL, getFilterClause } from './utilities/urlBuilder';

const apiConnector = new APIConnector();
const debug = createDebug('print-template-service');

export const getPrintTemplates = async (): Promise<PrintTemplate[]> => {
    try {
        const url = 'card';
        const response = await apiConnector.fetchData(url);
        const json = await response.json();

        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }
            new Deserializer().deserialize(json, (err: any, printTemplate: any[]) => {
                if (err) {
                    return reject({status: response.status, message: genericError });
                }

                const printTemplates: PrintTemplate[] = printTemplate.map((c): PrintTemplate => {
                    return { value: c['id'], label: c['card-label-template'] };
                });

                return resolve(printTemplates);
            })

        });
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}

export const getPrintTemplatesWithPagination = async (listParameters?: ListQuery): Promise<{ rows: Name[], pagination: PaginationModel }> => {
    try {
        const filters: string = getFilterClause(listParameters?.filters, listParameters?.searchTerm)
        const paginationString = createPartialURL(listParameters?.goToPage, listParameters?.pageSize, listParameters?.sortBy, filters);
        const url = `card?${paginationString.slice(1)}`;
        const response = await apiConnector.fetchData(url);
        const json = await response.json();
        const newPagination = createPagination(json.meta);

        return new Promise((resolve, reject) => {
            if (json.errors) {
                return reject({status: response.status, message: getConstraintViolation(json.errors[0].detail) })
            }
            new Deserializer().deserialize(json, (err: any, printTemplate: any[]) => {
                if (err) {
                    debug('getPrintTemplates', err);
                    return reject(err);
                }

                const printTemplates: PrintTemplate[] = printTemplate.map((c): PrintTemplate => {
                    return { value: c['id'], label: c['card-label-template'] };
                });

                return resolve({ rows: printTemplates, pagination: newPagination });
            })
        });
    } catch (error) {
        return new Promise((resolve, reject) => {
            reject(processServerError(error));
        });
    }
}
